import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '@components/button/button.module';
import { DropdownButtonComponent } from './dropdown-button.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule
  ],
  declarations: [DropdownButtonComponent],
  exports: [DropdownButtonComponent]
})
export class DropdownButtonModule {}
